const main = () => {
    document.querySelectorAll('[data-sort-dropdown]').forEach((dropdown) => {
        const trigger = dropdown.querySelector('.c-forms-sort-dropdown__trigger');
        const list = dropdown.querySelector('.c-forms-sort-dropdown__list');
        const label = dropdown.querySelector('.c-forms-sort-dropdown__trigger-label');
        const items = dropdown.querySelectorAll('.c-forms-sort-dropdown__item');

        if (!trigger || !list || !label) return;

        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const isOpen = dropdown.hasAttribute('data-open');
            closeAllDropdowns();
            if (!isOpen) {
                dropdown.setAttribute('data-open', '');
                trigger.setAttribute('aria-expanded', 'true');
            }
        });

        items.forEach((item) => {
            item.addEventListener('click', () => {
                const href = item.getAttribute('data-href');
                if (href) {
                    window.location.assign(href);
                    return;
                }
                items.forEach((i) => {
                    i.classList.remove('is-active');
                    i.setAttribute('aria-selected', 'false');
                });
                item.classList.add('is-active');
                item.setAttribute('aria-selected', 'true');
                label.textContent = item.querySelector('.c-forms-sort-dropdown__item-label').textContent;
                closeDropdown(dropdown);
            });
        });
    });

    document.addEventListener('click', () => {
        closeAllDropdowns();
    });

    function closeDropdown(dropdown) {
        dropdown.removeAttribute('data-open');
        const trigger = dropdown.querySelector('.c-forms-sort-dropdown__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function closeAllDropdowns() {
        document.querySelectorAll('[data-sort-dropdown][data-open]').forEach((d) => {
            closeDropdown(d);
        });
    }
};

export default main;
